<template>
    <base-dialog :loading="loading" :value="dialog" :width="780" :fullscreen="isMobile" :title="$t('routines.assign_routine')"
        @input="val => { if (!val) hide() }" @close="hide">
        <div class="asg-grid">
            <div class="asg-left">
                <set-selection-routine :coach-id="coachId" @change="onChangeSelection"
                    @collection="collection = $event" />
                <div class="asg-warn">
                    <v-icon size="16" color="#D97706">mdi-alert-outline</v-icon>
                    <span>{{ $t('routines.alert_replace_routines') }}</span>
                </div>
            </div>
            <div class="asg-right">
                <div class="asg-hint">{{ $t('routines.select_days_to_assign') }}</div>
                <mini-calendar :value="dates" @change="dates = $event" />
                <div class="mt-4">
                    <kimsa-combobox :label="$t('routines.destination_routine')" dense :items="routineOptions"
                        :value="routineDestiny" @change="routineDestiny = $event" no-object ref="routineDestiny" />
                </div>
            </div>
        </div>

        <template v-slot:footer>
            <dialog-actions hide-cancel :confirm-label="$t('common.assign')" :disabled="disabled" :loading="loading"
                @confirm="assign" />
        </template>
    </base-dialog>
</template>

<script>

import { db } from "@/utils/Firebase";
import SetSelectionRoutine from './SetSelectionRoutine.vue';
import MiniCalendar from "@/components/common/MiniCalendar";
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";
import BaseDialog from "@/components/common/BaseDialog";
import DialogActions from "@/components/common/DialogActions";
import { assignRoutineToSelection } from "@/utils/Exercises";

export default {
    name: "AssignRoutineDialog",
    components: { SetSelectionRoutine, MiniCalendar, KimsaCombobox, BaseDialog, DialogActions },
    props: {
        routineId: {
            type: String,
            default: null,
        },
        coachId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            dialog: false,
            routine: null,
            loading: false,
            currentSelection: null,
            collection: null,
            dates: [],
            routineDestiny: 1,
        }
    },
    computed: {
        routineOptions(vm = this) {
            return [1, 2].map(value => ({ name: `${vm.$t('common.routine')} ${value}`, value }))
        },
        disabled(vm = this) {
            return !vm.currentSelection || vm.dates.length === 0 || !vm.routine
        },
    },
    methods: {
        async show() {
            const vm = this
            vm.dialog = true
            await vm.loadRoutine()
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        reset() {
            const vm = this
            vm.routine = null
            vm.valid = false
            vm.currentSelection = null
            vm.dates = []
            vm.routineDestiny = 1
            if (vm.$refs.routineDestiny) vm.$refs.routineDestiny.model = 1
        },
        async loadRoutine() {
            let vm = this
            if (!vm.routineId) return
            let routineRef = await db.collection('routines').doc(vm.routineId).get()
            vm.routine = { ...routineRef.data(), id: routineRef.id }
        },
        onChangeSelection(selection) {
            const vm = this;
            vm.currentSelection = selection
        },
        async assign() {
            const vm = this
            if (!vm.routine) return vm.toast(vm.$t('common.an_error_has_occurred'), 'error')
            vm.loading = true
            try {
                await assignRoutineToSelection({
                    routine: vm.routine,
                    collection: vm.collection,
                    selection: vm.currentSelection,
                    dates: vm.dates,
                    routineNumber: vm.routineDestiny,
                })

                vm.hide()
                vm.toast(vm.$t('routines.assigned_routines_successfully'))
            } catch (err) {
                if (err?.code !== 'already-exists') vm.toast(vm.$t('common.an_error_has_occurred'), 'error')
            } finally {
                vm.loading = false
            }
        },
    },
    watch: {

        routineId() {
            this.loadRoutine()
        },
    }
}
</script>

<style scoped>
.asg-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: -20px;
}

.asg-left {
    padding: 24px;
    border-right: 1px solid var(--v-outline-base);
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.asg-right {
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.asg-hint {
    font-size: 11px;
    font-weight: 600;
    color: var(--v-txtMuted-base);
    text-transform: uppercase;
    letter-spacing: .06em;
    text-align: center;
    margin-bottom: 8px;
}

.asg-warn {
    margin-top: auto;
    display: flex;
    gap: 10px;
    align-items: flex-start;
    background: rgba(217, 119, 6, .08);
    border: 1px solid rgba(217, 119, 6, .35);
    border-radius: 8px;
    padding: 12px 14px;
    font-size: 12px;
    color: #D97706;
    line-height: 1.5;
}

@media (max-width: 768px) {
    .asg-grid {
        grid-template-columns: 1fr;
    }

    .asg-left {
        border-right: none;
        border-bottom: 1px solid var(--v-outline-base);
    }
}
</style>